import { trioUITheme } from '@/styles/theme';
import { AvailableRoles } from '@/types';

export const rolesColors: { [role in AvailableRoles]: string } = {
  [AvailableRoles.ACADEMY_ADMIN]: trioUITheme.colors['neutral-40'],
  [AvailableRoles.ACADEMY_USER]: trioUITheme.colors['neutral-30'],
  [AvailableRoles.FREELANCE_REVIEWER]: trioUITheme.colors['neutral-20'],
  [AvailableRoles.FREELANCE_SOURCER]: trioUITheme.colors['neutral-20'],
  [AvailableRoles.HIRING_ADMIN]: trioUITheme.colors['neutral-40'],
  [AvailableRoles.HIRING_USER]: trioUITheme.colors['neutral-30'],
  [AvailableRoles.INSIDE_REVIEWER]: trioUITheme.colors['neutral-30'],
  [AvailableRoles.INSIDE_SOURCER]: trioUITheme.colors['neutral-30'],
  [AvailableRoles.PEOPLE_ADMIN]: trioUITheme.colors['neutral-40'],
  [AvailableRoles.PEOPLE_USER]: trioUITheme.colors['neutral-30'],
  [AvailableRoles.SEO_ADMIN]: trioUITheme.colors['neutral-40'],
  [AvailableRoles.SEO_USER]: trioUITheme.colors['neutral-30'],
  [AvailableRoles.FINANCE_ADMIN]: trioUITheme.colors['neutral-40'],
  [AvailableRoles.FINANCE_USER]: trioUITheme.colors['neutral-30'],
};
